import { IgnorableNetworkError } from '@/Factories/BookingkitApi/Errors/IgnorableNetworkError';
export class UnAuthorisedError extends IgnorableNetworkError {
    constructor(...params: any) {
        super(...params);
        this.message = `${this.message}`;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UnAuthorisedError);
        }

        this.name = 'UnAuthorisedError';
    }

    static fromUnAuthorisedRequest():UnAuthorisedError {
        return new UnAuthorisedError('This request was unauthorised');
    }
}

export default { UnAuthorisedError };
